import { useIsFetching } from '@tanstack/react-query';

/**
 * A page is ready for height settlement once none of its mounted, enabled
 * React Query observers are fetching. Inactive requests from a previous tab
 * and disabled/deferred queries intentionally do not block the current page.
 */
export const useWidgetPageSettled = (): boolean =>
  useIsFetching({ type: 'active' }) === 0;
